import { postWrapper } from '../wrapper/PostWrapper'
import { scrollListener } from './ScrollListener'
import { loaderComponent } from '../components/LoaderComponent'
class AsyncLoader {
	posts = []
	activeCategoryId
	finished = false
	status = 'NEW'

	setWebsiteService (websiteService) {
		this.websiteService = websiteService
		return this
	}

	setActiveCategoryId (activeCategoryId) {
		this.activeCategoryId = activeCategoryId
		return this
	}

	setFinished (finished) {
		this.finished = finished
		if (finished) scrollListener.removeListener()
		return this
	}

	setStatus (status) {
		if (this.status !== status) loaderComponent.handler(status)
		this.status = status
		return this
	}

	async loadMorePosts () {
		if (this.finished) return false
		if (!this.activeCategoryId) {
			const posts = await this.websiteService.getPosts({
				offset: this.offset
			})
			posts.forEach(post => this.addPost(post))
		} else {
			const posts = await this.websiteService.getPostsForCategory({
				offset: this.offset,
				activeCategoryId: this.activeCategoryId
			})
			posts.forEach(post => this.addPost(post))
		}
	}

	addPost (post) {
		this.posts.push(post)
		postWrapper.render(post)
	}

	get offset () {
		return this.posts.length
	}
}

const asyncLoader = new AsyncLoader()
export { AsyncLoader, asyncLoader }



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/mod_async_posts_loader/core/AsyncLoader.js